require('./index.less');
var locale = require('../i18n');
var tpl = require('./index.html');

var domain = location.hostname.match(/\w+\.\w+$/);
var isProduction = /enhancer\.io$/.test(domain);
var projectId = (location.pathname.match(/proj\/(\d+)/) || [])[1];
var baseUrl = (isProduction ? '//previewer.enhancer.io/proj/'
                    : '//previewer.enhancer.cc/proj/') + projectId;

var VariableWhiteList =  {
    'BASE_URL': true,
    'CURR_YEAR': true,
    'CURR_MONTH': true,
    'CURR_DATE': true,
    'CURR_TIME': true,
    'CURR_YY': true,
    'CURR_MM': true,
    'CURR_DD': true,
    'CURR_YMD': true,
    'LAST_YEAR': true,
    'LAST_MONTH': true,
    'LAST_MM': true,
    'YESTERDAY': true,
    'YESTERDAY_YMD': true,
    'NEXT_YEAR': true,
    'NEXT_MONTH': true,
    'NEXT_MM': true,
    'TOMORROW': true,
    'TOMORROW_YMD': true,

    'USER_ID': true,
    'USER_NAME': true,
    'ROLES': true,
    'ROLE_DISPLAY_NAMES': true,
    'IP': true,
    'UA':  true,

    '0-BASE_URL': true,
    '0-CURR_YEAR': true,
    '0-CURR_MONTH': true,
    '0-CURR_DATE': true,
    '0-CURR_TIME': true,
    '0-CURR_YY': true,
    '0-CURR_MM': true,
    '0-CURR_DD': true,
    '0-CURR_YMD': true,
    '0-LAST_YEAR': true,
    '0-LAST_MONTH': true,
    '0-LAST_MM': true,
    '0-YESTERDAY': true,
    '0-YESTERDAY_YMD': true,
    '0-NEXT_YEAR': true,
    '0-NEXT_MONTH': true,
    '0-NEXT_MM': true,
    '0-TOMORROW': true,
    '0-TOMORROW_YMD': true,

    '1-USER_ID': true,
    '1-USER_NAME': true,
    '1-ROLES': true,
    '1-ROLE_DISPLAY_NAMES': true,
    '1-IP': true,
    '1-UA':  true
};

var variableManager = {
    init: function() {
        var that = this;
        var envVars = JSON.parse(localStorage.getItem('envVars'));
        if (!envVars) {
            var d = new Date();
            var yd = new Date(d.getTime() - 86400000);
            var nd = new Date(d.getTime() + 86400000);
            var dt = d.getDate();
            var m = d.getMonth();
            var lm = m == 0 ? 12 : m;
            var nm = m == 11 ? 1 : (m + 2);
            var xx = function(x) {
                return x < 10 ? ('0' + x) : (x + '');
            };
            var ymd = function(date) {
                return date.toISOString().split('T')[0];
            }
            envVars = {
                'BASE_URL': baseUrl,
                'CURR_YEAR': d.getFullYear(),
                'CURR_MONTH': m + 1,
                'CURR_DATE': dt,
                'CURR_TIME': d.getTime(),
                'CURR_YY': d.getFullYear() % 100 + '',
                'CURR_MM': xx(m + 1),
                'CURR_DD': xx(dt),
                'CURR_YMD': ymd(d),
                'LAST_YEAR': d.getFullYear() - 1,
                'LAST_MONTH': lm,
                'LAST_MM': xx(lm),
                'YESTERDAY': yd.getDate(),
                'YESTERDAY_YMD': ymd(yd),
                'NEXT_YEAR': d.getFullYear() + 1,
                'NEXT_MONTH': nm,
                'NEXT_MM': xx(nm),
                'TOMORROW': nd.getDate(),
                'TOMORROW_YMD': ymd(nd),
                
                'USER_ID': 'zhangsan',
                'USER_NAME': '张三',
                'ROLES': '',
                'ROLE_DISPLAY_NAMES': '<无角色>',
                'IP': '1.2.3.4',
                'UA': {
                    isDesktop: true,
                    browser: 'enhancer_chrome',
                    version: '63.40.951',
                    os: 'Windows 10',
                    platform: 'Windows'
                },
                '1-USER_ID': 'zhangsan',
                '1-USER_NAME': '张三',
                '1-ROLES': '',
                '1-ROLE_DISPLAY_NAMES': '<无角色>',
                '1-IP': '1.2.3.4',
                '1-UA': {
                    isDesktop: false,
                    browser: 'enhancer_chrome',
                    version: '63.40.951',
                    os: 'Windows 10',
                    platform: 'Windows'
                },
                '0-BASE_URL': baseUrl,
                '0-CURR_YEAR': d.getFullYear(),
                '0-CURR_MONTH': m + 1,
                '0-CURR_DATE': dt,
                '0-CURR_TIME': d.getTime(),
                '0-CURR_YY': d.getFullYear() % 100 + '',
                '0-CURR_MM': xx(m + 1),
                '0-CURR_DD': xx(dt),
                '0-CURR_YMD': ymd(d),
                '0-LAST_YEAR': d.getFullYear() - 1,
                '0-LAST_MONTH': lm,
                '0-LAST_MM': xx(lm),
                '0-YESTERDAY': yd.getDate(),
                '0-YESTERDAY_YMD': ymd(yd),
                '0-NEXT_YEAR': d.getFullYear() + 1,
                '0-NEXT_MONTH': nm,
                '0-NEXT_MM': xx(nm),
                '0-TOMORROW': nd.getDate(),
                '0-TOMORROW_YMD': ymd(nd)
            };
            localStorage.setItem('envVars', JSON.stringify(envVars));
            window.location.reload();
        }
    },
    close: function() {
        this.$mask.show();
        if (this.$dlg) {
            this.$dlg.hide();
            this.$mask.hide();
        }
    },
    __show: function() {
        if ($('body').width() < 720) {
            this.$dlg.css({
                transform: 'translateX(-100%)',
                opacity: 0
            })
            .show()
            .animate({
                opacity: 1,
                transform: 'translateX(-50%)'
            }, 300, 'swing');
        } else {
            this.$mask.show();
            this.$dlg.show();
        }
    },
    open: function() {
        var that = this;

        $('p.vs-error-tips').hide();
        if (that.$dlg) {
            var vars = JSON.parse( localStorage.getItem('envVars') );
            var $vTab = $( '.variable-table>tbody' ).html('');
            for ( var i in vars ) {
                that.__addVar( $vTab, i, vars[ i ] );
            }
            that.__show();
            return
        }
        that.$dlg = $(tpl({
            locale: locale()
        })).appendTo($('body'));

        that.$mask = $('<div>').addClass('variable-settings-mask').appendTo($('body'));

        that.$dlg.find('button.add-var')
            .click( function() {
                that.__editVar( that.__addVar( $vTab, '', '' ) );
            } )
        that.$dlg.find('.variable-filter').on('keyup', function(e) {
            var key = $(this).val().replace(/^\s*|\s*$/g, '').toUpperCase();

            if (!key) {
                return $('.variable-table tbody tr').show();
            }
            $('.variable-table tbody tr').hide();
            $(".variable-table tbody tr[varname*='" + key + "']").show();
        });

        var vars = JSON.parse( localStorage.getItem('envVars') );
        var $vTab = $( '.variable-table>tbody' ).html('');
        for ( var i in vars ) {
            that.__addVar( $vTab, i, vars[ i ] );
        }

        that.$dlg.find('.var-button-save').on('click', function() {
            if ( $vTab.find('tr[editting]').size() > 0 ) {
                $('p.vs-error-tips')
                    .append('<span class="fas fa-exclamation-triangle">')
                    .append(locale('varUnstored'))
                    .show();
                return;
            }
            $('p.vs-error-tips').hide();
            var vars = that.__getVars( $vTab );
            localStorage.setItem('envVars', JSON.stringify(vars));
            that.close()
            window.location.reload();
        });
        that.$dlg.find('.var-button-cancel').on('click', function() {
            that.close();
        });
        that.__show();
    },
    __addVar: function( $vTab, key, val ) {
        return $( '<tr class="ui-widget-content">'
            + '<td class="name">' + key + '</td>'
            + '<td class="value">' + JSON.stringify( val ) + '</td>'
            + '<td class="type">' + (typeof val) + '</td>'
            + '<td class="scope">' + ( /^\d+\-/.test(key) ? 'client' : 'server' ) + '</td>'
            + '</tr>' )
            .attr('varname', key.toUpperCase())
            .append(
                $( '<td class="operations">' )
                    .append(
                        $('<span>').addClass('fas fa-pencil-alt').attr('title', locale('edit'))
                            .click( function() {
                                
                                if ( $(this).hasClass( 'fa-pencil-alt' ) ) {
                                    variableManager.__editVar( $(this).parent().parent() );
                                } else {
                                    variableManager.__saveEdit( $(this).parent().parent() )
                                }
                            } )
                    )
                    .append(
                        VariableWhiteList[key] ? ''
                          : $( '<span>' ).addClass('fas fa-minus').attr('title',locale('delete'))
                            .click( function() {
                                variableManager.__deleteVar( $(this).parent().parent() )
                            } )
                    )
            ).dblclick( function() {
                variableManager.__editVar( $(this) );
            } )
            .prependTo( $vTab );
    },
    __editVar: function( $tr ) {
        if ( $tr.attr( 'editting' ) === 'editting' ) {
            return;
        }
        var key = $tr.find( 'td.name' ).text();
        var val = $tr.find( 'td.value' ).text();
        var type = $tr.find( 'td.type' ).text();
        var reserved = VariableWhiteList[key.toUpperCase()];

        var $key = $('<input>')
                    .addClass(reserved ? 'reserved' : 'ui-widget-content')
                    .val(key)
                    .prop('readonly', reserved);

        $tr.find( 'td.name' ).html( '' )
            .append( $key );

        $tr.find( 'td.value' ).html( '' )
            .append( $('<input class="ui-widget-content">').val(val) );

        var $sel = $('<select class="ui-widget-content">'
                + '<option>string</option>'
                + '<option>number</option>'
                + '<option>object</option>'
                + '</select>').val(type);

        $tr.find( 'td.type' ).html( '' ).append( $sel );
        
        if (reserved) {
            $sel.addClass('ui-state-disabled').prop('disabled', true);
        }

        $tr.find( 'td.operations span.fa-pencil-alt' )
            .removeClass( 'fa-pencil-alt' )
            .addClass( 'fa-save' )
            .parent().attr( 'title', locale('save') );

        $tr.attr( "editting", "editting" );
    },
    __saveEdit: function( $tr ) {
        var $key = $tr.find( 'td.name>input' );
        var key = $key.val();
        if ( key  === '' 
            || (!/^\d-\w+(\.\w+)*$/.test( key ) && !/^\w+(\.\w+)*$/.test( key ))
        ) {
            $key.addClass( 'ui-state-error' );
            return false;
        }

        var $type = $tr.find( 'td.type>select' );
        var type = $type.val();
        var $val = $tr.find( 'td.value>input' );
        var val = $val.val();
        if ( type === 'number' && !/^((\d+)|(\d+\.\d+))$/.test( val ) ) {
            $val.addClass( 'ui-state-error' );
            $type.addClass( 'ui-state-error' );
            return false;
        }
        // tolerate any input value with string type.
        if ( type === 'string') {
            val = '"' + val.replace(/^('|")/g, '').replace(/('|")$/g, '') + '"';
        }

        if ( type === 'object' ) {
            try {
                JSON.parse( val );
            } catch ( e ) {
                $val.addClass( 'ui-state-error' );
                $type.addClass( 'ui-state-error' );
                return false;
            }
        }
        
        $key.parent().html( $key.val() );
        $val.parent().html( val );
        $type.parent().html( $type.val() );

        $tr.find('td.scope')
            .html( /^\d+\-/.test(key) ? 'client' : 'server' );

        $tr.find( 'td.operations span.fa-save' )
            .removeClass( 'fa-save' )
            .addClass( 'fa-pencil-alt' )
            .parent().attr( 'title', locale('edit') );
        $tr.removeAttr( "editting" );
        return true;
    },
    __deleteVar: function( $tr ) {
        $tr.remove();
    },
    __getVars: function( $vTab ) {
        var vars = {}, $tr;
        $vTab.find('tr').each( function() {
            $tr = $(this);
            var key = $tr.find( 'td.name' ).text();
            var val = $tr.find( 'td.value' ).text();
            var type = $tr.find( 'td.type' ).text();
            if ( !key ) {
                return true;
            }
            vars[ key ] = JSON.parse(val);
        } );
        return vars;
    },
    getServerVars: function() {
        var vars = JSON.parse( localStorage.getItem('envVars') );
        var serverVars = {};
        for (var i in vars) {
            if (/^\w+(\.\w+)*$/.test(i)) {
                serverVars[i.toUpperCase()] = vars[i];
            }
        }
        return serverVars;
    },
    getVars: function() {
        var vars = JSON.parse( localStorage.getItem('envVars') );
        return vars;
    },
    setVars: function(variables) {
        if (!variables) {
            return;
        }
        var vars = JSON.parse( localStorage.getItem('envVars') );
        for (var i in variables) {
            vars[i.toUpperCase()] = variables[i];
        }
        localStorage.setItem('envVars', JSON.stringify(vars));
    },
    getVar: function(name) {
        if (!name) {
            return
        }
        var vars = JSON.parse( localStorage.getItem('envVars') );
        return vars[name.toUpperCase()];
    },
    setVar: function(name, value) {
        var vars = JSON.parse( localStorage.getItem('envVars') ) || {};
        vars[name.toUpperCase()] = value;
        localStorage.setItem('envVars', JSON.stringify(vars));
    }
}

module.exports = variableManager;



//////////////////
// WEBPACK FOOTER
// ./src/tools/variable-manager/index.js
// module id = 7
// module chunks = 0 1 2